import React, { useEffect, useState } from 'react';
import BrandsTable from '../components/BrandsTable';
import styles from './BrandGenAIPage.module.css'; // Reuse a neutral page style
import DataFallback from '../components/feedback/DataFallback';

export default function BrandsPage() {
  const [brands, setBrands] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
      setError('Not authenticated');
      setLoading(false);
      return;
    }
    fetch(process.env.REACT_APP_API_BASE_URL + '/brands/', {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    })
      .then(res => {
        if (!res.ok) { const e = new Error(`HTTP ${res.status}`); e.status = res.status; throw e; }
        return res.json();
      })
      .then(data => {
        console.log('API Response:', data); // Debug log
        // Handle the API response structure {brands: [...]}
        const brandsArray = data.brands || [];
        setBrands(brandsArray);
        setLoading(false);
      })
      .catch(err => {
        setError(err.message);
        setLoading(false);
      });
  }, []);

  return (
    <div className={styles.page}>
      {loading ? (
        <div>Loading brands...</div>
      ) : error ? (
        <DataFallback
          variant="table"
          error={typeof error === 'string' ? { message: error, retryable: true } : error}
          onRetry={() => window.location.reload()}
        />
      ) : (
        <BrandsTable brands={brands} />
      )}
    </div>
  );
}
